import config from '../config';
import { EMPTY_XLSX_BASE64 } from './emptyXlsxBase64';
import fileService from '../services/fileService';

const XLSX_MIME =
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
const CSV_MIME = 'text/csv';

export function getGridBaseUrl(): string {
  return (config.grid?.baseUrl || 'https://grid.cynayd.com').replace(/\/$/, '');
}

export function isSpreadsheetFile(nameOrExt?: string | null, mimeType?: string | null): boolean {
  const name = (nameOrExt || '').toLowerCase();
  if (name.endsWith('.xlsx') || name === 'xlsx') return true;
  if (name.endsWith('.csv') || name === 'csv') return true;
  if (mimeType === XLSX_MIME) return true;
  if (mimeType === CSV_MIME || mimeType === 'application/csv') return true;
  return false;
}

export function buildEditInGridUrl(driveFileId: string): string {
  const base = getGridBaseUrl();
  return `${base}/open/drive?driveFileId=${encodeURIComponent(driveFileId)}`;
}

export function openFileInGrid(driveFileId: string): void {
  window.open(buildEditInGridUrl(driveFileId), '_blank', 'noopener,noreferrer');
}

function base64ToUint8Array(base64: string): Uint8Array {
  const binary = atob(base64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i += 1) {
    bytes[i] = binary.charCodeAt(i);
  }
  return bytes;
}

export function createEmptyXlsxFile(fileName = 'Untitled Spreadsheet.xlsx'): File {
  const bytes = base64ToUint8Array(EMPTY_XLSX_BASE64);
  return new File([bytes], fileName, { type: XLSX_MIME });
}

/**
 * Upload an empty .xlsx into the current folder and open it in Grid.
 */
export async function createAndOpenNewSpreadsheet(folderId?: string | null): Promise<string> {
  const stamp = new Date().toISOString().slice(0, 19).replace(/[:T]/g, '-');
  const file = createEmptyXlsxFile(`Untitled Spreadsheet ${stamp}.xlsx`);
  const uploaded = await fileService.uploadFile(file, {
    folderId: folderId && folderId !== 'root' ? folderId : undefined,
  });
  const raw = uploaded as { id?: string; file?: { id?: string }; data?: { id?: string; file?: { id?: string } } };
  const id = raw?.file?.id || raw?.id || raw?.data?.file?.id || raw?.data?.id;
  if (!id) {
    throw new Error('Upload succeeded but no file id was returned');
  }
  openFileInGrid(id);
  return id;
}
